import { useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { usePageView } from 'src/hooks/use-page-view';
import { OverviewSingle } from 'src/sections/overview-single';
import { OverviewMultis } from 'src/sections/overview-multis';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { useRouter } from 'src/hooks/use-router';
import TitleButton from 'src/components/ui/headers/title-button';
import PageSection from 'src/layouts/page-section';
import { paths } from 'src/paths';
import { gotoListPage } from 'src/utils/navigation-utils';

const Page = ({ items }) => {
  const rootRef = useRef(null);
  const { t } = useTranslation();
  const router = useRouter();
  usePageView();

  return (
    <PageSection title="Overview" rootRef={rootRef}>
      <Grid
        container
        disableEqualOverflow
        spacing={3}
      >
        <Grid xs={12}>
          <TitleButton label={t(tokens.nav.overview)} />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            title='Vi phạm nội quy'
            value='0'
            imgIcon='/assets/iconly/iconly-glass-chart.svg'
            button={'Chi tiết'}
            onClicked={() => {
                
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            title='Học viên phản ánh'
            value='0'
            button={'Chi tiết'}
            imgIcon='/assets/iconly/iconly-glass-star.svg'
            onClicked={() => {
                
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewMultis 
            values={['100', '105']}
            title="Giờ (Lịch / Thực tế)"
            imgIcon='/assets/iconly/iconly-glass-clock.svg' />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            title='Nhiên liệu tháng'
            value='0'
            imgIcon='/assets/iconly/iconly-glass-info.svg'
            button={'Chi tiết'}
            onClicked={() => {
                
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            title='Km trong tháng'
            value='0'
            button={'Chi tiết'}
            onClicked={() => {
                
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            title='Tới hạn bảo dưỡng'
            value='0'
            imgIcon='/assets/iconly/iconly-glass-message.svg'
            button={'Chi tiết'}
            onClicked={() => {
                
              }
            } />
        </Grid>
        
      </Grid>
    </PageSection>
  );
};

export default Page;
